module.exports = __webpack_public_path__ + "static/media/VXC.166229f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/VXC.png
// module id = 488
// module chunks = 0